<aside class="left-menu">
  <div class="left-menu__top">
    <!-- =====================================================
         Brand
         ===================================================== -->

    <div class="left-menu__brand">
      <a [routerLink]="['/']">
        <img
          [src]="assetUrl + 'icons/gloget_logo-trans.png'"
          alt="gloget logo"
        />
      </a>
    </div>

    <!-- =====================================================
         Profile
         ===================================================== -->

    @if (user) {
      <section class="profile-card">
        <img
          class="profile-card__avatar"
          [src]="assetUrl + 'img/avatar1.png'"
          alt="User avatar"
        />

        <div class="profile-card__info">
          <strong>
            {{ user.full_name || "User" }}
          </strong>

          <span>
            {{ user.email }}
          </span>

          <small>
            {{ user.role_name || "Customer" }}
          </small>
        </div>
      </section>
    }

    <!-- =====================================================
         Global salon context
         Business owner only
         ===================================================== -->

    @if (canSelectSalons && salonContext.salons().length) {
      <section class="salon-context" (click)="$event.stopPropagation()">
        <span class="salon-context__label"> Salon View </span>

        <!-- Trigger -->

        <button
          type="button"
          class="salon-context__trigger"
          [class.is-open]="salonMenuOpen"
          (click)="toggleSalonMenu($event)"
        >
          <div class="salon-context__icon">
            <img [src]="assetUrl + 'icons/marker-lg.svg'" alt="" />
          </div>

          <div class="salon-context__copy">
            <small> Viewing </small>

            <strong>
              {{ salonContext.selectionLabel() }}
            </strong>
          </div>

          <img
            class="salon-context__chevron"
            [class.is-open]="salonMenuOpen"
            [src]="assetUrl + 'icons/chevron-down.svg'"
            alt=""
          />
        </button>

        <!-- Dropdown -->

        @if (salonMenuOpen) {
          <div class="salon-context__menu">
            <div class="salon-context__menu-head">
              <strong> Filter business </strong>

              <span> Select one or more salons </span>
            </div>

            <!-- All Salons -->

            <button
              type="button"
              class="salon-option"
              [class.is-selected]="salonContext.allSelected()"
              (click)="toggleAllSalons($event)"
            >
              <span class="salon-option__check">
                @if (salonContext.allSelected()) {
                  <span>✓</span>
                }
              </span>

              <div class="salon-option__copy">
                <strong> All salons </strong>

                <small> Combined business view </small>
              </div>
            </button>

            <div class="salon-context__divider"></div>

            <!-- Individual Salons -->

            @for (salon of salonContext.salons(); track salon.salon_id) {
              <button
                type="button"
                class="salon-option"
                [class.is-selected]="isSalonSelected(salon.salon_id)"
                (click)="toggleSalon(salon.salon_id, $event)"
              >
                <span class="salon-option__check">
                  @if (isSalonSelected(salon.salon_id)) {
                    <span>✓</span>
                  }
                </span>

                <div class="salon-option__copy">
                  <strong>
                    {{ salon.name }}
                  </strong>

                  @if (salon.city) {
                    <small>
                      {{ salon.city }}
                    </small>
                  }
                </div>
              </button>
            }
          </div>
        }
      </section>
    }

    <!-- =====================================================
         Rewards
         ===================================================== -->

    @if (showPoints) {
      <section class="rewards-card">
        <div class="rewards-card__head">
          <div>
            <img [src]="assetUrl + 'icons/diamond.svg'" alt="" />

            <strong> Silver </strong>
          </div>

          <span> 1202 Points </span>
        </div>

        <div class="rewards-card__bar">
          <span [style.width.%]="ratingProgress"></span>
        </div>
      </section>
    }

    <!-- =====================================================
         Navigation
         ===================================================== -->

    <nav class="menu-nav">
      <a
        *ngFor="let item of menuItems"
        [routerLink]="item.link"
        routerLinkActive="is-active"
        [routerLinkActiveOptions]="{
          exact: false,
        }"
        class="menu-nav__item"
      >
        <img [src]="item.icon" [alt]="item.alt" />

        <span>
          {{ item.label }}
        </span>
      </a>
    </nav>
  </div>

  <!-- =====================================================
       Bottom
       ===================================================== -->

  <div class="left-menu__bottom">
    <section class="support-card">
      <span> Need help or support? </span>

      <p>Get the answers you need quickly.</p>

      <glo-button
        icon="search-white"
        [fullWidth]="true"
        type="black"
        value="Support"
        (click)="openSupport()"
      ></glo-button>
    </section>

    <button type="button" class="logout-btn" (click)="onLogout()">
      <img [src]="assetUrl + 'icons/logout.svg'" alt="" />

      <span> Logout </span>
    </button>
  </div>
</aside>
